import {
  Paper,
  createStyles,
  TextInput,
  PasswordInput,
  Checkbox,
  Button,
  Title,
  Text,
  Anchor,
  SimpleGrid,
  rem,
  Group,
  Grid,
  Image,
  Center,
  ScrollArea,
} from '@mantine/core';
import LoginForm from '../components/forms/LoginForm';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import bottlesImage from '../assets/images/login_page_obrc.jpg';

const breakpoints = [576, 768, 1600, 1975]

const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

const useStyles = createStyles((theme) => ({
  wrapper: {
    minHeight: rem(900),
    backgroundSize: 'cover',
    backgroundImage: `url(${bottlesImage})`,
  },

  form: {
    borderRight: `${rem(1)} solid ${
      theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[3]
    }`,
    maxWidth: rem(450),
    paddingTop: rem(80),

    [theme.fn.smallerThan('sm')]: {
      maxWidth: '100%',
    },
  },

  bottledropimg: {
    objectFit: 'cover',
    height: '700px',
    width: '1100px',
    '@media (max-width: 1250px)': {
      display: 'none'
    },
  },

  title: {
    color: theme.colorScheme === 'dark' ? theme.white : theme.black,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
  },
}));

const UserLogin = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const authState = useSelector((state) => state.auth);

  useEffect(() => {
    if(authState.isAuthenticated) {
      navigate(searchParams.get("continueWith") || "/");
    }
  }, [authState]);

  return (
    <Center h='100%'>
      <ScrollArea offsetScrollbars>
        <Group align='center' spacing='xl' noWrap>
          <Paper className={classes.form} radius={0} p={30} withBorder miw={500} h={700}>
            <Title order={2} className={classes.title} ta="center" mt="md" mb={50}>
              Welcome back to OBRC!
            </Title>
            <LoginForm />
          </Paper>
          <img className={classes.bottledropimg} src={bottlesImage} />
        </Group>
      </ScrollArea>
    </Center>
  );
}

export default UserLogin;